var _path, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80039 20.3492L5.312 21.0092C4.22668 21.2145 3.18041 20.5011 2.97508 19.4158C2.9286 19.1701 2.9286 18.9179 2.97508 18.6722L3.63504 15.1838C3.70976 14.7889 3.90175 14.4256 4.18597 14.1414L15.9033 2.42411C16.512 1.81539 17.4419 1.66448 18.2119 2.04947L18.9815 2.43424C20.093 2.99 20.9942 3.89127 21.55 5.00277L21.9348 5.77232C22.3198 6.5423 22.1688 7.47224 21.5601 8.08096L9.84282 19.7983C9.5586 20.0825 9.19534 20.2745 8.80039 20.3492ZM8.18069 18.431L8.42861 18.3841L16.7665 10.0462L13.9381 7.21776L5.60018 15.5556L5.55328 15.8035L8.18069 18.431ZM20.1459 6.66675L18.1807 8.63197L15.3523 5.80354L17.3175 3.83832L18.087 4.22309C18.8115 4.58532 19.3989 5.17275 19.7611 5.8972L20.1459 6.66675Z",
    fill: "#979797"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80039 20.3492L5.312 21.0092C4.22668 21.2145 3.18041 20.5011 2.97508 19.4158C2.9286 19.1701 2.9286 18.9179 2.97508 18.6722L3.63504 15.1838C3.70976 14.7889 3.90175 14.4256 4.18597 14.1414L15.9033 2.42411C16.512 1.81539 17.4419 1.66448 18.2119 2.04947L18.9815 2.43424C20.093 2.99 20.9942 3.89127 21.55 5.00277L21.9348 5.77232C22.3198 6.5423 22.1688 7.47224 21.5601 8.08096L9.84282 19.7983C9.5586 20.0825 9.19534 20.2745 8.80039 20.3492ZM8.18069 18.431L8.42861 18.3841L16.7665 10.0462L13.9381 7.21776L5.60018 15.5556L5.55328 15.8035L8.18069 18.431ZM20.1459 6.66675L18.1807 8.63197L15.3523 5.80354L17.3175 3.83832L18.087 4.22309C18.8115 4.58532 19.3989 5.17275 19.7611 5.8972L20.1459 6.66675Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b4d795c1a043de4b32e220cc7d916fb2.svg";
export { ForwardRef as ReactComponent };